import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { EditableMultiLine } from "widgets/inputs";
import { DocumentSuggestions, handleLink } from "widgets/others";

import { Base } from "../base";
import { Text as TextReadOnly } from "../../renderers/text";

import styles from "./text.css";

export function Text(props) {
  const { column, show, value, pos, suggestionList } = props;
  const baseRef = useRef(null);
  const inputRef = useRef(null);
  const suggestionRef = useRef(null);
  const onEnterCalled = useRef(false);
  const [currentValue, setCurrentValue] = useState(value);
  const [readOnly, setReadOnly] = useState(true);
  const [isLink, setIsLink] = useState(false);
  useEffect(
    function onValueChange() {
      setCurrentValue(value || "");
      setReadOnly(true);
      baseRef.current.stopEditing();
      setIsLink(handleLink(value));
    },
    [value, pos]
  );

  useEffect(
    function onShowChange() {
      if (!show) {
        baseRef.current.stopEditing();
      }
    },
    [show]
  );

  return (
    <Base
      {...props}
      ref={baseRef}
      onEditing={(value) => {
        setReadOnly(false);
        if (value) {
          setCurrentValue(value);
        }
        setTimeout(() => {
          if (value) {
            baseRef.current.dataChanged(value);
          }
          inputRef.current?.focus();
          suggestionRef.current?.show();
        });
      }}
      type="text"
      doubleClickToEdit={!isLink}
    >
      {readOnly ? (
        <TextReadOnly
          {...props}
          style={{
            lineHeight: 1.67,
            padding: "0.8rem",
            width: `${column.width}px`,
            wordBreak: "break-word"
          }}
          isFocused={show}
          onDoubleClick={() => {
            !column.readOnly && baseRef.current.startEditing();
          }}
        />
      ) : (
        <EditableMultiLine
          value={currentValue}
          ref={inputRef}
          className={`${styles.editable} ${
            column.readOnly ? styles.readonly : ""
          }`}
          onEnter={(value, e) => {
            onEnterCalled.current = true;
            e.preventDefault();
            baseRef.current.dataChanged(value);
            baseRef.current.dataCompleted();
            baseRef.current.moveNextLine();
          }}
          onSave={(value, e) => {
            if (onEnterCalled.current) {
              onEnterCalled.current = false;
              return;
            }
            let trimmedText = value && value.trim();
            value = value && !trimmedText.length ? trimmedText : value;
            baseRef.current.dataChanged(value);
            baseRef.current.dataCompleted();
          }}
          onCancel={() => {
            baseRef.current.dataChanged(value);
            baseRef.current.dataCompleted();
          }}
          onChange={(value) => {
            baseRef.current.dataChanged(value);
          }}
          onKeyPress={(e) => {
            if (e.key === "Tab") {
              e.preventDefault();
            }
            e.stopPropagation();
          }}
          onKeyDown={(e) => {
            if (e.key === "Tab") {
              baseRef.current.dataChanged(e.target.textContent);
              baseRef.current.dataCompleted();
              e.preventDefault();
              if (e.shiftKey) {
                baseRef.current.movePrevious();
              } else {
                baseRef.current.moveNext();
              }
            }
            suggestionRef.current?.onKeyDown(e, column, false);
            e.stopPropagation();
          }}
        />
      )}
      {!readOnly && suggestionList?.length > 0 && (
        <DocumentSuggestions
          ref={suggestionRef}
          onSelect={(value) => {
            onEnterCalled.current = true;
            baseRef.current.dataChanged(value);
            baseRef.current.dataCompleted();
            baseRef.current.moveNextLine();
          }}
          suggestionList={suggestionList}
        />
      )}
      {/* <input
        value={currentValue}
        ref={inputRef}
        className={`${style.input} base`}
        onInput={(e) => {
          setCurrentValue(e.target.value);
          baseRef.current.dataChanged(e.target.value);
        }}
        onKeyDown={(e) => {
          console.log("KEY DOWN INNER", e.key);
          if (e.key === "Enter") {
            e.preventDefault();
            return baseRef.current.dataCompleted();
          }
          if (e.key === "Escape") {
            baseRef.current.dataChanged(value);
            return baseRef.current.dataCompleted();
          }
          if (e.key === "Tab") {
            baseRef.current.dataChanged(value);
            return baseRef.current.dataCompleted();
          }
          e.stopPropagation();
        }}
        onBlur={(e) => {
          // baseRef.current.dataChanged(e.target.value);
          baseRef.current.dataCompleted();
        }}
      /> */}
    </Base>
  );
}

Text.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  suggestionList: PropTypes.array,
  pos: PropTypes.any,
  show: PropTypes.bool
};
